import GenderReportContainer from './gender_report_container';

const GenderReport = GenderReportContainer;
export default GenderReport;
